const axios = require('axios')

export default {
  async getSkills () {
    return axios.get('/api/skills').then(r => r.data)
  },
  async updateSkills (data) {
    return axios.put('/api/skills', data).then(r => r.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/skills.js